import { STORE_ID, PLANS_STORE_ID, CURRENCY, CONTRACT_ID } from '@Config/app.config';
import { getLanguageCode } from '@Utils/language/language';

export const getRemoteConfig = (categoryId: string): types.endpoints.IEndpointConfig => {
	return {
		url: `/search/resources/api/v2/products?categoryId=${categoryId}&contractId=${CONTRACT_ID}&currency=${CURRENCY}&storeId=${STORE_ID}&langId=${getLanguageCode()}&catalogId=${PLANS_STORE_ID}`,
	};
};
